import React, { useContext, useState, useEffect } from 'react';
import { Modal } from 'flowbite-react';
import axios from 'axios';
import Select from 'react-select';
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import { FaArrowLeft } from 'react-icons/fa';
import engineGif from "../image/engine.gif";

const Service_details = ({ view_data, view_details, setSwap }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [currentSpare, setCurrentSpare] = useState(null);
    const [currentServiceId, setCurrentServiceId] = useState(null);
    const [newSpare, setNewSpare] = useState({ spare_id: null, spare_name: '', quantity: '', price: '' });
    const { globalValue } = useContext(GlobalContext);
    const [sparelog, setSparelog] = useState([]);
    const [spareOptions, setSpareOptions] = useState([]);

    const [loading, setLoading] = useState(false);


    const spareLog = async (service) => {
        setLoading(true);
        try {
            const response = await axios.post(`${globalValue}/spareLog`, {
                service,
                estimate_id: view_data.estimate_data.estimate_id,
            }, {
                headers: {
                    "x-access-token": sessionStorage.getItem("token"),
                },
            });
            setSparelog(response.data);
            const options = response.data.map((spare) => ({
                value: spare[0],
                label: spare[1],
            }));
            setSpareOptions(options);
            console.log(options);
        } catch (error) {
            console.error("Error fetching spare log:", error);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (modalOpen && modalType !== 'delete') {
            spareLog(currentServiceId);
        }
    }, [modalOpen, modalType, currentServiceId]);

    const openModal = (type, serviceId, spare = null) => {
        setModalType(type);
        setCurrentServiceId(serviceId);
        setCurrentSpare(spare);
        setModalOpen(true);

        if (type === 'add') {
            setNewSpare({ spare_id: null, spare_name: '', quantity: '', price: '' });
        } else if (type === 'edit' && spare) {
            setNewSpare({
                spare_id: spare.spare_id,
                spare_name: spare.spare_name,
                quantity: spare.quantity,
                price: spare.price.toString(),
            });
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setCurrentSpare(null);
        setCurrentServiceId(null);
    };

    const handleSave = () => {
        if (modalType === 'add') {

            setLoading(true);
            axios
                .post(`${globalValue}/addSpare`, { ...newSpare, service_id: currentServiceId, estimate_id: view_data.estimate_data.estimate_id }, {
                    headers: {
                        "x-access-token": sessionStorage.getItem("token"),
                    },
                })
                .then(response => {

                    if (response.data === "success") {
                        closeModal();
                        view_details(view_data.estimate_data.estimate_id);
                        Swal.fire({
                            icon: "success",
                            title: "Spare  added to successfully",
                        });

                    }
                    else if (response.data === "failure") {
                        closeModal();
                        view_details(view_data.estimate_data.estimate_id);
                        Swal.fire({
                            icon: "warning",
                            title: "Spare  already exist",
                        });

                    }

                })
                .catch(error => {
                    console.error('Error adding spare:', error);
                }).finally(() => setLoading(false))
        }
        else if (modalType === 'edit') {

            setLoading(true);
            axios
                .post(`${globalValue}/editSpare_service`, {
                    spare_id: currentSpare.spare_id,
                    quantity: newSpare.quantity,
                    price: newSpare.price,
                    service_id: currentServiceId,
                    estimate_id: view_data.estimate_data.estimate_id
                }, {
                    headers: {
                        "x-access-token": sessionStorage.getItem("token"),
                    },
                })
                .then(response => {
                    if (response.data === "success") {
                        closeModal();
                        view_details(view_data.estimate_data.estimate_id);

                    }
                    else if (response.data === "lessquantity") {
                        closeModal();
                        view_details(view_data.estimate_data.estimate_id);
                        Swal.fire({
                            icon: "warning",
                            title: "Amount of spare is already used ",
                        });

                    }
                })
                .catch(error => {
                    console.error('Error editing spare:', error);
                }).finally(() => setLoading(false))

        }
    };

    const [currentquantity, setCurrentquantity] = useState("");
    const handleDelete = () => {
        setLoading(true)
        axios
            .post(`${globalValue}/deleteSpare_service`, {
                spare_id: currentSpare.spare_id,
                estimate_id: view_data.estimate_data.estimate_id,
                quantity: currentquantity
            }, {
                headers: {
                    "x-access-token": sessionStorage.getItem("token"),
                },
            })
            .then(response => {
                if (response.data === "success") {
                    closeModal();
                    view_details(view_data.estimate_data.estimate_id);

                }
            })
            .catch(error => {
                console.error('Error deleting spare:', error);
            }).finally(() => setLoading(false));
    };


    if (!view_data.estimate_data) {
        return <div>Loading customer data...</div>;
    }

    return (
        <div className="space-y-6 overflow-auto">
            <div className="p-4 bg-white rounded shadow-xl border border-gray-300 relative">

                {loading && (
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
                        <img src={engineGif} alt="Loading..." className="w-24 h-24" />
                    </div>
                )}
                <div className="flex gap-6">
                    <button onClick={() => setSwap(true)} className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300">
                        <FaArrowLeft className="w-4 h-4" />
                    </button>
                    <h2 className="text-xl font-semibold">Customer Information</h2></div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
                    <div className='flex'>
                        <strong>Customer ID:</strong> {view_data.estimate_data.customer_id}
                    </div>
                    <div>
                        <strong>Estimate ID:</strong> {view_data.estimate_data.estimate_id}
                    </div>
                    <div>
                        <strong>Date:</strong>{' '}
                        {new Date(view_data.estimate_data.s_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        })}
                    </div>
                </div>
            </div>

            {view_data.services.map((service, index) => {
                const categoryData = view_data.estimate_data.service_category.find(
                    cat => cat.service_id === service.service_id
                );

                return (
                    <div key={index} className="p-6 bg-white rounded-lg shadow-md border border-gray-300">
                        <div className="flex justify-between items-center mb-4">
                            <div>
                                <h3 className="text-2xl font-medium">{service.service_name}</h3>
                                <span className="text-gray-500">Service ID: {service.service_id}</span>
                            </div>
                        </div>

                        {service.spares.length > 0 ? (
                            <div className="overflow-auto max-h-64 border rounded mb-6">
                                <table className="min-w-full border-collapse">
                                    <thead>
                                        <tr className="bg-gray-100 text-gray-600">
                                            <th className="p-3 border border-gray-300">Spare Name</th>
                                            <th className="p-3 border border-gray-300">Quantity</th>
                                            <th className="p-3 border border-gray-300">MRP</th>
                                            <th className="p-3 border border-gray-300">Estimated Price</th>
                                            <th className="p-3 border border-gray-300 w-36">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {service.spares.map((spare, spareIndex) => (
                                            <tr key={spareIndex} className="text-gray-700 hover:bg-gray-50">
                                                <td className="p-3 border border-gray-300">{spare.spare_name}</td>
                                                <td className="p-3 border border-gray-300">{spare.quantity}</td>
                                                <td className="p-3 border border-gray-300">
                                                   Rs. {spare.mrp != null && !isNaN(spare.mrp) ? Number(spare.mrp).toFixed(2) : "0.00"}
                                                </td>
                                                <td className="p-3 border border-gray-300">Rs. {spare.price.toFixed(2)}</td>
                                                <td className="p-3 border border-gray-300 flex justify-center gap-2">
                                                    <button
                                                        onClick={() => openModal("edit", service.service_id, spare)}
                                                        className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        onClick={() => { openModal("delete", service.service_id, spare); setCurrentquantity(spare.quantity) }}
                                                        className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <p className="text-gray-500 mb-6">No spares associated with this service.</p>
                        )}

                        {categoryData && categoryData.subcategories && categoryData.subcategories.length > 0 && (
                            <div className="overflow-auto max-h-64 border rounded">
                                <table className="min-w-full border-collapse">
                                    <thead>
                                        <tr className="bg-gray-100 text-gray-600">
                                            <th className="p-3 border border-gray-300">Category Name</th>
                                            <th className="p-3 border border-gray-300">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {categoryData.subcategories.map((sub, subIndex) => (
                                            <tr key={subIndex} className="text-gray-700 hover:bg-gray-50">
                                                <td className="p-3 border border-gray-300">{sub.name}</td>
                                                <td className="p-3 border border-gray-300">Rs. {parseFloat(sub.amount).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                );
            })}

            {(() => {
                const sparesTotal = (view_data.services || []).reduce((sum, svc) => {
                    const svcTotal = (svc.spares || []).reduce((s, sp) => {
                        const qty = parseFloat(sp.quantity) || 0;
                        const price = parseFloat(sp.price) || 0;
                        return s + qty * price;
                    }, 0);
                    return sum + svcTotal;
                }, 0);
                const categoryTotal = (view_data.estimate_data?.service_category || []).reduce((sum, cat) => {
                    const catTotal = (cat.subcategories || []).reduce((s, sub) => s + (parseFloat(sub.amount) || 0), 0);
                    return sum + catTotal;
                }, 0);
                const labourTotal = (view_data.services || []).reduce((sum, svc) => sum + (parseFloat(svc.labour_charge) || 0), 0);
                const grandTotal = (sparesTotal + categoryTotal + labourTotal).toFixed(2);
                return (
                    <div className="mt-6 flex justify-end">
                        <table className="w-full sm:w-1/2 border border-gray-300 text-sm border-collapse">
                            <tbody>
                                <tr>
                                    <td className="border px-3 py-2 font-semibold text-right">Total Amount</td>
                                    <td className="border px-3 py-2 text-right">Rs. {grandTotal}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            })()}


            <Modal show={modalOpen} onClose={closeModal}>
                <Modal.Header className="flowbite-modal-h">
                    {modalType === 'add'
                        ? 'Add Spare'
                        : modalType === 'edit'
                            ? 'Edit Spare'
                            : 'Delete Spare'}
                </Modal.Header>
                <Modal.Body className="flowbite-modal-h">
                    {modalType !== 'delete' ? (
                        <>
                            {modalType === "add" ? <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700">Spare Name</label>
                                <Select
                                    options={spareOptions}
                                    onChange={(selectedOption) =>
                                        setNewSpare({
                                            ...newSpare,
                                            spare_id: selectedOption?.value || null,
                                            spare_name: selectedOption?.label || '',
                                        })
                                    }
                                    value={spareOptions.find(option => option.label === newSpare.spare_name)}
                                    placeholder="Select Spare Name"
                                />
                            </div> : <p className=''></p>}
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700">Quantity</label>
                                <input
                                    type="number"
                                    min="0"
                                    className="mt-1 p-2 w-full border rounded"
                                    value={newSpare.quantity}
                                    onChange={(e) => setNewSpare({ ...newSpare, quantity: e.target.value })}
                                />
                            </div>
                            {/* <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700">Price</label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    className="mt-1 p-2 w-full border rounded"
                                    value={newSpare.price}
                                    onChange={(e) => setNewSpare({ ...newSpare, price: e.target.value })}
                                />
                            </div> */}
                        </>
                    ) : (
                        <div>
                            <p className="text-gray-700">Are you sure you want to delete this spare?</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="flowbite-modal-h">
                    <button
                        onClick={closeModal}
                        className="px-4 py-2 bg-gray-300 text-white rounded hover:bg-gray-400"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={modalType === 'delete' ? handleDelete : handleSave}
                        disabled={
                            modalType !== 'delete' &&
                            (!newSpare.quantity || !newSpare.price || newSpare.quantity < 1 || newSpare.price < 1 || (modalType === 'add' && !newSpare.spare_id))
                        }
                        className={`px-4 py-2 text-white rounded ${modalType === 'delete'
                            ? 'bg-red-500 hover:bg-red-600'
                            : 'bg-blue-500 hover:bg-blue-600'
                            } ${modalType !== 'delete' &&
                                (!newSpare.quantity || !newSpare.price || newSpare.quantity < 1 || newSpare.price < 1 || (modalType === 'add' && !newSpare.spare_id))
                                ? 'bg-gray-300 cursor-not-allowed'
                                : ''}`}
                    >
                        {modalType === 'delete' ? 'Delete' : 'Save'}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Service_details;
